/*
Note, some holidays changes dates every year
> option 1: pull from dbo.Holidays once then save to localStorage
            if already exist in localStorage, use it
            add checking if holidays in localStorage does not exist
> option 2: update the dates in this code every year while populating the dbo.HolidaysRef table
*/
export default {
    getSeasonDetails(userFirstName = null) {    
        const today = new Date()
        const month = today.getMonth() // 0–11
        const day = today.getDate()

        // Default result
        const result = {
            greeting: null,
            personalize: false,
            buttonColor: "#1976D2",
            className: "welcome-section",
            classNameMobile: "welcome-section-mobile"
        }

        // Helper for personalization with correct punctuation
        // personalize: boolean whether to personalize
        // isFestive: boolean controls exclamation behavior
        const formatGreeting = (base, personalize = false, isFestive = false) => {
            // if no personalization requested, return base as-is
            if (!personalize || !userFirstName) return base

            if (isFestive) {
                // Remove trailing "!" to avoid double punctuation, then add ", Name!"
                const clean = base.replace(/!+$/, "")
                return `${clean}, ${userFirstName}!`
            }

            // Solemn → no exclamation mark, but include name after comma
            return `${base}, ${userFirstName}`
        }

        // --- FESTIVE HOLIDAYS (with !) ---

        // 🎆 New Year (Dec 31–Jan 2)
        if ((month === 11 && day === 31) || (month === 0 && day <= 2)) {
            const base = "🎆 Maligayang Bagong Taon!"
            result.personalize = true
            result.greeting = formatGreeting(base, result.personalize, true)
            result.buttonColor = "#FFD600"
            result.className = "welcome-section-newyear"
            result.classNameMobile = "welcome-section-newyear-mobile"
        }

        // 💖 Valentine’s Day
        if (month === 1 && day === 14) {
            const base = "💖 Happy Valentine’s Day!"
            result.personalize = true
            result.greeting = formatGreeting(base, result.personalize, true)
            result.buttonColor = "#D81B60"
            result.className = "welcome-section-valentine"
            result.classNameMobile = "welcome-section-valentine-mobile"
        }

        // 💼 Labor Day
        if (month === 4 && day === 1) {
            const base = "💼 Maligayang Araw ng mga Manggagawa!"
            result.personalize = true
            result.greeting = formatGreeting(base, result.personalize, true)
            result.buttonColor = "#007ACC"
            result.className = "welcome-section-laborday"
            result.classNameMobile = "welcome-section-laborday-mobile"
        }

        // 🇵🇭 Independence Day
        if (month === 5 && day === 12) {
            const base = "🇵🇭 Maligayang Araw ng Kalayaan!"
            result.personalize = true
            result.greeting = formatGreeting(base, result.personalize, true)
            result.buttonColor = "#20a7db"
            result.className = "welcome-section-independence"
            result.classNameMobile = "welcome-section-independence-mobile"
        }

        // 🎃 Halloween
        if (month === 9 && (day === 30 || day === 31)) {
            const base = "🎃 Happy Halloween!"
            result.personalize = true
            result.greeting = formatGreeting(base, result.personalize, true)
            result.buttonColor = "#FB8C00"
            result.className = "welcome-section-halloween"
            result.classNameMobile = "welcome-section-halloween-mobile"
        }

        // 🎄 Christmas (Dec 1–25)
        if (month === 11 && day >= 1 && day <= 25) {
            const base = "🎄 Maligayang Pasko!"
            result.personalize = true
            result.greeting = formatGreeting(base, result.personalize, true)
            result.buttonColor = "#00695C"
            result.className = "welcome-section-christmas"
            result.classNameMobile = "welcome-section-christmas-mobile"
        }

        // --- SOLEMN HOLIDAYS (no !) ---

        // ☪️ Eid’l Fitr
        if (month === 2 && day === 20) {
            const base = "☪️ Eid al-Fitr Mubarak"
            result.personalize = false
            result.greeting = formatGreeting(base, result.personalize, false)
            result.buttonColor = "#388E3C"
            result.className = "welcome-section-eid"
            result.classNameMobile = "welcome-section-eid-mobile"
        }

        // ✝️ Holy Week
        if (month === 3 && day >= 1 && day <= 5) {
            const base = "✝️ Mapagpalang Semana Santa"
            result.personalize = false
            result.greeting = formatGreeting(base, result.personalize, false)
            result.buttonColor = "#5D4037"
            result.className = "welcome-section-holyweek"
            result.classNameMobile = "welcome-section-holyweek-mobile"
        }

        // 🇵🇭 Day of Valor
        if (month === 3 && day === 9) {
            const base = "🇵🇭 Paggunita sa Araw ng Kagitingan"
            result.personalize = false
            result.greeting = formatGreeting(base, result.personalize, false)
            result.buttonColor = "#0288D1"
            result.className = "welcome-section-valor"
            result.classNameMobile = "welcome-section-valor-mobile"
        }

        // 🕊 Ninoy Aquino Day
        if (month === 7 && day === 21) {
            const base = "🕊 Paggunita sa Ninoy Aquino Day"
            result.personalize = false
            result.greeting = formatGreeting(base, result.personalize, false)
            result.buttonColor = "#a67c00"
            result.className = "welcome-section-ninoy"
            result.classNameMobile = "welcome-section-ninoy"
        }

        // 🦸 National Heroes Day
        if (month === 7 && day === 31) {
            const base = "🦸 Pagpupugay sa Araw ng mga Bayani"
            result.personalize = false
            result.greeting = formatGreeting(base, result.personalize, false)
            result.buttonColor = "#a98600"
            result.className = "welcome-section-heroesday"
            result.classNameMobile = "welcome-section-heroesday-mobile"
        }

        // 🕯 All Saints’ Day / Undas
        if (month === 10 && day >= 1 && day <= 2) {
            const base = "🕯 Pag-alala sa Ating mga Yumao (Undas)"
            result.personalize = false
            result.greeting = formatGreeting(base, result.personalize, false)
            result.buttonColor = "#9E9E9E"
            result.className = "welcome-section-allsaints"
            result.classNameMobile = "welcome-section-allsaints-mobile"
        }

        // 🇵🇭 Bonifacio Day
        if (month === 10 && day === 30) {
            const base = "🇵🇭 Pagpupugay kay Andres Bonifacio"
            result.personalize = false
            result.greeting = formatGreeting(base, result.personalize, false)
            result.buttonColor = "#C62828"
            result.className = "welcome-section-bonifacio"
            result.classNameMobile = "welcome-section-bonifacio-mobile"
        }

        // 🙏 Immaculate Conception
        if (month === 11 && day === 8) {
            const base = "🙏 Kapistahan ng Immaculate Conception"
            result.personalize = false
            result.greeting = formatGreeting(base, result.personalize, false)
            result.buttonColor = "#3F51B5"
            result.className = "welcome-section-immaculate"
            result.classNameMobile = "welcome-section-immaculate-mobile"
        }

        // 🇵🇭 Rizal Day
        if (month === 11 && day === 30) {
            const base = "🇵🇭 Paggunita kay Dr. José Rizal"
            result.personalize = false
            result.greeting = formatGreeting(base, result.personalize, false)
            result.buttonColor = "#0038A8"
            result.className = "welcome-section-rizalday"
            result.classNameMobile = "welcome-section-rizalday-mobile"
        }

        return result;
    }
};




